import { Slice } from "./cartCountSlice";

const { actions } = Slice;

export const setCartCount = (queryParams: any) => (
  dispatch: (arg0: { payload: any; type: string }) => void
) => {
  // dispatch(actions.startCall({ callType: callTypes.list }));
  return dispatch(actions.countSet(queryParams));
};
